<h2 mat-dialog-title>
  {{ 'OMNISEARCH.SWITCH_TO_PARTNER' | translate }}
</h2>
<div class="searchbox">
  <mat-form-field floatLabel="never">
    <input
      matInput
      #searchTerm
      [placeholder]="'OMNISEARCH.SEARCH_BY_PID' | translate"
      (keyup.enter)="switchPartner(searchTerm.value)"
      autocomplete="off"
    />
  </mat-form-field>
</div>
<mat-dialog-content>
  <mat-nav-list>
    <h3 matSubheader *ngIf="(recentPartners$ | async)?.length > 0">
      {{ 'OMNISEARCH.RECENT' | translate }}
    </h3>
    <a
      tabindex="0"
      mat-list-item
      *ngFor="let recentPartner of recentPartners$ | async"
      (click)="switchPartner(recentPartner.id)"
      (keyup.enter)="switchPartner(recentPartner.id)"
    >
      <h4 matListItemTitle class="row-title">
        {{ recentPartner.id }}
        <span *ngIf="recentPartner.subscription_tier_id">({{ recentPartner.subscription_tier_id }})</span>
      </h4>
      <p matListItemLine>
        {{ recentPartner.name }}
        <span *ngIf="recentPartner.address_line_one">
          - {{ recentPartner.address_line_one }} {{ recentPartner.city }} {{ recentPartner.state_code }}
        </span>
      </p>
    </a>
    <mat-divider *ngIf="(partners$ | async)?.length > 0 && (recentPartners$ | async)?.length > 0"></mat-divider>
    <h3 matSubheader *ngIf="(partners$ | async)?.length > 0">
      {{ 'OMNISEARCH.SEARCH_RESULTS' | translate }}
    </h3>
    <a
      tabindex="0"
      mat-list-item
      *ngFor="let partner of partners$ | async"
      (click)="switchPartner(partner.id)"
      (keyup.enter)="switchPartner(partner.id)"
    >
      <h4 matListItemTitle class="row-title">{{ partner.id }} ({{ partner.subscription_tier_id }})</h4>
      <p matListItemLine>
        {{ partner.name }}
        <span *ngIf="partner.address_line_one">
          - {{ partner.address_line_one }} {{ partner.city }} {{ partner.state_code }}
        </span>
      </p>
    </a>
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
